import { ATOM_KEY } from "@/shared/client/keys";
import { atom, useRecoilState, useSetRecoilState, useRecoilValue } from "recoil";

const toggleAtom = atom({
    default: false,
    key: ATOM_KEY.TOGGLE_ON_OFF,
});

export const useToggleState = () => useRecoilState(toggleAtom);
export const useSetToggleState = () => useSetRecoilState(toggleAtom);
export const useToggleValue = () => useRecoilValue(toggleAtom);
